import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { proceedingParticipantsApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

export function useParticipantReactivate(participantId: string, onSuccess: () => void) {
  const { t } = useTranslation();
  const { showSuccess } = useAlertContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => proceedingParticipantsApi.reactivateProceedingParticipant({ participantId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.ProceedingParticipants] });
      showSuccess(t("proceedingParticipants.reactivate.successfullyReactivated"));
      onSuccess();
    },
  });
}
